import Vue from 'vue'
import { ApolloClient, DefaultOptions } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { onError } from 'apollo-link-error'
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'
import { alerts } from './utils'
import store from './store'

const tokenUser = localStorage.getItem('token_aqua')
const typeToken = localStorage.getItem('type_token')
const token = (typeToken || '') + ' ' + (tokenUser || '')

const httpLink = new HttpLink({
    uri: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_GRAPHQL_ENDPOINT_LOCAL : process.env.VUE_APP_GRAPHQL_ENDPOINT_PRODUCTION,
    headers: {
        authorization: token
    }
})

// Error Handling
const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        graphQLErrors.map(async ({ message, locations, path }) => {
            if (message === 'Unauthenticated.') {
                await alerts.confirm('Su sesión ha expirado, debe iniciar sesion nuevamente', false, 'error')
                store.commit('auth/detroyToken')
                location.reload()
            } else {
                alerts.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
            }
        }
        )
    }
    if (networkError) alert(`[Network error]: ${networkError}`)
})

const defaultOptions: DefaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore'
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
    }
}

// Create the apollo client
export const apolloClient = new ApolloClient({
    link: errorLink.concat(httpLink),
    cache: new InMemoryCache({
        addTypename: false
    }),
    connectToDevTools: true,
    defaultOptions: defaultOptions
})

// Install the Vue plugin
Vue.use(VueApollo)

export const apolloProvider = new VueApollo({
    defaultClient: apolloClient
})
